/**
 * A searchable select's options change with what is typed, and each search
 * returns new objects. The selected option stays the same object until the value
 * changes, as the select overwrites what is being typed when it gets a new one.
 */
export const resolveSelectedOption = (
  options,
  optionValue,
  selectedValue,
  lastSelected
) =>
  lastSelected?.[optionValue] === selectedValue
    ? lastSelected
    : (options.find((option) => option[optionValue] === selectedValue) ?? null)
